

import { Component, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClassificationDetail } from '../../../models/classification.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-classification-details',
  template: `
    <kv-datatable
        [allowsMultiSelection]="false"
        id="dt_classification_details"
        sectionTitle="{{ 'common.classification_details_title' | translate }}"
        listTitle="{{ 'common.classification_details_list_title' | translate }}"
        [numRowsPerPage]="10"
        [titles]="titles"
        [items]="this.svc.details"
        deleteButton="{{ 'common.delete' | translate }}"
        addButton="{{ 'common.add' | translate }}"
        (onAdd)="showAddDialog($event)"
        (onCancelDetail)="this.svc.editingDetail=null"
        [editable]="true"
        (onEditInline)="onEditInline($event)"
        (onDelete)="onDeleteInline($event)"
        [customButtons]="customButtons"
        (onCustomButton)="onCustomButton($event)"
    >
      <app-classification-details-form
          *ngIf="this.svc.editingDetail"
          [editingElement]="this.svc.editingDetail"
          (onAddElement)="onAdd($event)"
      >
      </app-classification-details-form>
    </kv-datatable>
  `
})

export class ClassificationDetails2Component implements OnChanges {

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  @Output() onBackClick: EventEmitter<any> = new EventEmitter();

  constructor (
    public svc: ClassificationService,
    private translate: TranslateService,
    private srvDataTable: DataTableService) {
      this.svc.getDetails(this.svc.editing.id).subscribe();

      this.translate.get([
        'common.classification_details_code',
        'common.classification_details_desc',
        'common.back'
      ]).subscribe((res) => {
        console.log(res);
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'code', label: res['common.classification_details_code'], editable: true },
          { id: 'description', label: res['common.classification_details_desc'], editable: true }
        ];

        this.customButtons = [{
            callbackname: 'back',
            isAlwaysEnabled: true,
            label: res['common.back'],
            icon: 'fa fa-angle-double-left'
        }]

      })
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  onEditInline(event) {
    this.svc.putDetails(event).subscribe();
    this.svc.editingDetail = null;
  }

  onDeleteInline(event) {
    this.svc.deleteDetail(event).subscribe();
  }

  onAdd(event) {
    event.certification_id = this.svc.editing.id;
    this.svc.postDetails(event).subscribe();
    this.svc.editingDetail = null;
    this.srvDataTable.get('dt_classification_details').showDetail = false;
  }

  showAddDialog(data) {
    console.log('add', data)
    this.svc.editingDetail = new ClassificationDetail();
  }

  onCustomButton(event) {
    switch (event.callbackName) {
      case 'back':
        this.onBackClick.emit();
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-details.component.ts